import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { SupportTicket, SupportTicketStatus } from '@models';
import { Observable } from 'rxjs';

@Injectable()
export class SupportTicketsService extends HttpService<SupportTicket> {
  protected override collectionPath = '/support-tickets';

  getTicketsCollectionByQuery(
    params?: Record<string, string | number | boolean | undefined>
  ) {
    return this.getCollectionByQuery(params);
  }

  getTicketById(id: number | string) {
    return this.getItemById(id);
  }

  createTicket<SupportTicket>(
    item: Partial<SupportTicket> | FormData
  ): Observable<SupportTicket> {
    if (item instanceof FormData) {
      return this.createItem<SupportTicket>(item);
    }
    return this.createItem<SupportTicket>(item);
  }

  updateStatus(
    id: number,
    updatedStatus: SupportTicketStatus
  ): Observable<SupportTicket> {
    return this.http.put<SupportTicket>(`${this.apiUrl}/${id}/status`, {
      status: updatedStatus,
    });
  }

  deleteTicketById(id: number | string): Observable<unknown> {
    return this.deleteItemById(id);
  }
}
